// Shared React Query keys only. Keep hook-private keys local until another
// module needs to invalidate or write the same cache family.
export const queryKeys = {
  contacts: {
    all: ["contacts"] as const,
    list: (query: unknown) => [...queryKeys.contacts.all, query] as const,
  },
  icps: {
    all: ["icps"] as const,
  },
};
